// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BasicOrderStateMapper from "../../mapper/BasicOrderStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = BasicOrderStateMapper.execute;

var BasicOrderResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var BasicOrderJsonResponseConverter = partial_arg(BasicOrderResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  BasicOrderResponseConverterConfig ,
  BasicOrderJsonResponseConverter ,
  
}
/* BasicOrderJsonResponseConverter Not a pure module */
